import { CLIENT } from '../constants';
import { FetchAPI } from '../Main/fetchAPI';
import { GetScheduleAllotmentReportProperties, GetScheduleReportProperties } from './scheduleReportProperties';

const SCHEDULE_REPORT = `${CLIENT}/reports/schedule`;

const buildQuery = (data: GetScheduleReportProperties) => {
	const query = new URLSearchParams();
	const { direction, endDate, orderBy, page, pageSize, searchString, startDate } = data;

	if (direction) query.set('direction', direction);
	if (orderBy) query.set('orderBy', orderBy);
	query.set('searchString', searchString);
	query.set('startDate', startDate);
	query.set('endDate', endDate);
	query.set('page', page);
	query.set('pageSize', pageSize);
	if (data.clientIds?.length) data.clientIds.forEach((id) => query.append('clientIds', id));
	if (data.providerId) query.set('providerId', data.providerId);
	if (data.caseManagerId) query.set('caseManagerId', data.caseManagerId);
	if (data.sessionTypeIds?.length) data.sessionTypeIds.forEach((id) => query.append('sessionTypeIds', id));
	if (data.statuses?.length) data.statuses.forEach((status) => query.append('statuses', status));
	if (data.cancellationStatusFilter) query.set('cancellationStatusFilter', data.cancellationStatusFilter);

	return query.toString();
};

const buildAllotmentQuery = (data: GetScheduleAllotmentReportProperties) => {
	const query = new URLSearchParams();
	const { direction, orderBy, page, pageSize, searchString } = data;

	if (direction) query.set('direction', direction);
	if (orderBy) query.set('orderBy', orderBy);
	query.set('searchString', searchString);
	query.set('page', page);
	query.set('pageSize', pageSize);
	if (data.caseManagerId) query.set('caseManagerId', data.caseManagerId);
	if (data.branchId) query.set('branchId', data.branchId);
	if (data.providerId) query.set('providerId', data.providerId);
	if (data.asOfDate) query.set('asOfDate', data.asOfDate);
	(data.clientIds ?? []).forEach((id) => query.append('clientIds', id));

	return query.toString();
};

export const ScheduleReport = {
	getRows: (data: GetScheduleReportProperties) =>
		FetchAPI.getJson({
			urlStr: `${SCHEDULE_REPORT}?${buildQuery(data)}`,
		}),
	getCancellationRows: (data: GetScheduleReportProperties) =>
		FetchAPI.getJson({
			urlStr: `${SCHEDULE_REPORT}/cancellations?${buildQuery(data)}`,
		}),
	getUtilizationRows: (data: GetScheduleReportProperties) =>
		FetchAPI.getJson({
			urlStr: `${SCHEDULE_REPORT}/utilization?${buildQuery(data)}`,
		}),
	getCacheStatus: (data: GetScheduleReportProperties) =>
		FetchAPI.getJson({
			urlStr: `${SCHEDULE_REPORT}/cache/status?${buildQuery(data)}`,
		}),
	refreshCache: (data: GetScheduleReportProperties) =>
		FetchAPI.postJson({
			urlStr: `${SCHEDULE_REPORT}/cache/refresh?${buildQuery(data)}`,
		}),
	downloadXlsx: (data: GetScheduleReportProperties) =>
		FetchAPI.getJson({
			urlStr: `${SCHEDULE_REPORT}/xlsx?${buildQuery(data)}`,
		}),
	downloadCancellationXlsx: (data: GetScheduleReportProperties) =>
		FetchAPI.getJson({
			urlStr: `${SCHEDULE_REPORT}/cancellations/xlsx?${buildQuery(data)}`,
		}),
	downloadUtilizationXlsx: (data: GetScheduleReportProperties) =>
		FetchAPI.getJson({
			urlStr: `${SCHEDULE_REPORT}/utilization/xlsx?${buildQuery(data)}`,
		}),
	getAllotmentRows: (data: GetScheduleAllotmentReportProperties) =>
		FetchAPI.getJson({
			urlStr: `${SCHEDULE_REPORT}/allotment?${buildAllotmentQuery(data)}`,
		}),
	downloadAllotmentXlsx: (data: GetScheduleAllotmentReportProperties) =>
		FetchAPI.getJson({
			urlStr: `${SCHEDULE_REPORT}/allotment/xlsx?${buildAllotmentQuery(data)}`,
		}),
};
